export const VISIT_STATUS_NAMES: any = {
  sheduled: 'Programada',
  rescheduled: 'Re programada',
  done: 'Finalizada',
  cancelled: 'Cancelada',
  deleted: 'Eliminada',
  pending_approval: 'Pendiente de aprobación',
};

export enum VISIT_STATUS {
  SCHEDULED = 'sheduled',
  RESCHEDULED = 'rescheduled',
  DONE = 'done',
  CANCELLED = 'cancelled',
  DELETED = 'deleted', // for pre sales
  PENDING_APPROVAL = 'pending_approval',
}

export enum VisitPreSaleState {
  PENDING_APPROVAL = 'pending_approval',
  SCHEDULED = 'scheduled',
  RESCHEDULED = 'rescheduled',
  DONE = 'done',
  DELETED = 'deleted',
}

export type VisitPreSaleStateType = VisitPreSaleState;

export const VISIT_PRE_SALE_STATUS_NAMES: any = {
  pending_approval: 'Pendiente de aprobación',
  scheduled: 'Programada',
  rescheduled: 'Reprogramada',
  done: 'Finalizada',
  deleted: 'Eliminada',
};

export const VISIT_PRE_SALE_STATUS_BADGE_COLOR: any = {
  pending_approval: 'warning',
  scheduled: 'info',
  rescheduled: 'warning',
  done: 'success',
  deleted: 'danger',
};

export const VISIT_STATUS_BADGE_COLOR: any = {
  pending_approval: 'warning',
  sheduled: 'info',
  rescheduled: 'warning',
  done: 'success',
  deleted: 'danger',
  cancelled: 'danger',
};
